/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListTriggerInstancesSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListTriggerInstancesRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListTriggerInstancesSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListTriggerInstancesSecurity$outboundSchema: z.ZodMiniType<
  ListTriggerInstancesSecurity$Outbound,
  ListTriggerInstancesSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listTriggerInstancesSecurityToJSON(
  listTriggerInstancesSecurity: ListTriggerInstancesSecurity,
): string {
  return JSON.stringify(
    ListTriggerInstancesSecurity$outboundSchema.parse(
      listTriggerInstancesSecurity,
    ),
  );
}

/** @internal */
export type ListTriggerInstancesRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListTriggerInstancesRequest$outboundSchema: z.ZodMiniType<
  ListTriggerInstancesRequest$Outbound,
  ListTriggerInstancesRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listTriggerInstancesRequestToJSON(
  listTriggerInstancesRequest: ListTriggerInstancesRequest,
): string {
  return JSON.stringify(
    ListTriggerInstancesRequest$outboundSchema.parse(
      listTriggerInstancesRequest,
    ),
  );
}
